module.exports = __webpack_public_path__ + "static/media/slingshot 2020.747db82e.glb";